var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"aula-img aula-img-variables",attrs:{"src":_vm.imgUrl,"alt":"","crossorigin":_vm.crossorigin},on:{"error":function($event){return _vm.$emit('error', $event)},"load":function($event){return _vm.$emit('load', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }